import React, { Component } from 'react';
import { Grid, Cell } from 'react-mdl';


class Landing extends Component {
  render() {
    return(
      <div style={{width: '100%', margin: 'auto'}}>
        <Grid className="landing-grid">
          <Cell col={12}>
            <img
              src="https://i.ibb.co/pfhRRw0/69672038-2400608320053803-1951630450652872704-n.jpg"
              alt="avatar"
              className="avatar-img"
              />

            <div className="banner-text">
            <h1>Selmi Ahmed<br></br></h1><h3>Web Developer</h3>

            <hr/>

          <p>HTML5 | CSS3 | Bootstrap | JavaScript | React | Angular | C# | Wordpress | Php | Java | Python </p>

        <div className="social-links">

          {/* LinkedIn */}
          <a href="https://www.linkedin.com/in/ahmed-selmi-7b8742191/" rel="noopener noreferrer" target="_blank">
            <i className="fa fa-linkedin-square" aria-hidden="true" />
          </a>

          {/* Github */}
          <a href="https://github.com/SelmiAhmed" rel="noopener noreferrer" target="_blank">
            <i className="fa fa-github-square" aria-hidden="true" />
          </a>

          {/* Freecodecamp */}
          <a href="https://www.freecodecamp.org/ahmed%20selmi" rel="noopener noreferrer" target="_blank">
            <i className="fa fa-free-code-camp" aria-hidden="true" />
          </a>

          {/* Youtube */}
          <a href="https://medium.com/@selmiahmed572" rel="noopener noreferrer" target="_blank">
<i class="fa fa-medium" aria-hidden="true"></i>
          </a>

        </div>
            </div>
          </Cell>
        </Grid>
      </div>
    )
  }
}

export default Landing;



// WEBPACK FOOTER //
// ./src/components/landingpage.js